import { Component, Input, OnInit } from "@angular/core";
import { OnboardingTaskStateService } from "./onboarding-task-state.service";

@Component({
  selector: "ab-onboarding-progress",
  templateUrl: "./onboarding-progress.component.html",
})
export class OnboardingProgressComponent implements OnInit {
  @Input() public project: any;
  @Input() public user: any;

  constructor(private onboardingTaskStateService: OnboardingTaskStateService) {}

  public ngOnInit() {
    this.onboardingTaskStateService.initForProject(this.project);
  }

  public totalCount() {
    return this.onboardingTaskStateService.checklistTasks.length;
  }

  public completedCount() {
    return this.onboardingTaskStateService.completedCount;
  }
}
